import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const CraftIdentityMatchesSort = ({ sortType, setSortType }) => {

  const allSortTypes = ["A-Z", "Z-A", "Ready to Craft"];
  const [isOpened, setIsOpened] = useState(false);
  const {pathname} = useLocation();





  return (
    <div className="card-details__sort" onClick={(e) => e.stopPropagation()}>
      <button
        className="card-details__sort-button"
        onClick={() => {
          setIsOpened(!isOpened)
        }}
        type="button"
      >
        <svg
          className="w-6 h-6 text-gray-800 dark:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M7 4v16M7 4l3 3M7 4 4 7m9-3h6l-6 6h6m-6.5 10 3.5-7 3.5 7M14 18h4"
          />
        </svg>
        Sort by: <strong>{sortType}</strong>
      </button>
      {(pathname.includes('/tutorial') || isOpened) && (
        <ul className="card-details__sort-list">
          {allSortTypes.map((item) => {
            return (
              <li
                className={`card-details__sort-item ${
                  sortType === item ? "active" : ""
                }`}
                key={item}
                onClick={() => {
                  setSortType(item);
                  setIsOpened(false);
                }}
              >
                {item}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default CraftIdentityMatchesSort;
